import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { DriverModel } from '../models/driver.model';
import { DriverRegistration } from '../models/user.registration';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { PaginatedResponse } from "../models/paginated-response";
import { Pagination } from "../shared/interfaces/pagination";
import { ChangePasswordModel } from "../models/change-password.model";

export interface DriversFilter {
  organizationId?: number;
  terminalId?: number;
  showDeleted?: boolean;
}

@Injectable()
export class DriverDataSource {

  constructor(
    private http: HttpClient,
  ) {
  }

  getAllDrivers(pagination: Pagination = {}, filters: DriversFilter = {}): Observable<PaginatedResponse<DriverModel>> {
    let params = new HttpParams();

    if (pagination.pageNumber) {
      params = params.append('pageNumber', pagination.pageNumber);
    }

    if (pagination.pageSize) {
      params = params.append('pageSize', pagination.pageSize);
    }

    if (pagination.removeLimit) {
      params = params.append('removeLimit', pagination.removeLimit);
    }

    if (filters.organizationId) {
      params = params.append('organizationIds', filters.organizationId);
    }
    if (filters.terminalId) {
      params = params.append('terminalIds', filters.terminalId);
    }
    if (filters.showDeleted) {
      params = params.append('showDeleted', filters.showDeleted);
    }
    return this.http.get<PaginatedResponse<DriverModel>>(environment.backendApi + 'api/Driver/GetDrivers', {params});
  }

  getDrivers(organizationId: number): Observable<DriverModel[]> {
    return this.http.get<DriverModel[]>(environment.backendApi + 'api/Driver/GetDrivers/' + organizationId);
  }

  createDriver(model: DriverRegistration): Observable<any> {
    const body: string = JSON.stringify(model);

    // Sends an authenticated request.
    return this.http.post<Response>(environment.backendApi + 'api/Driver/CreateDriver', body, {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    }).pipe(
      map((response: Response) => {
        return response;
      }),
      catchError((error: any) => {
        return throwError(error);
      }));
  }

  editDriver(model: DriverModel, driverId: number): Observable<any> {
    const body: string = JSON.stringify(model);

    // Sends an authenticated request.
    return this.http.put<Response>(environment.backendApi + 'api/Driver/UpdateDriver/' + driverId, body, {
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    }).pipe(
      map((response: Response) => {
        return response;
      }),
      catchError((error: any) => {
        return throwError(error);
      }));
  }

  deleteDriver(driverId: number): Observable<void> {
    return this.http.delete<void>(environment.backendApi + 'api/Driver/DeleteDriver/' + driverId);
  }

  changePassword(driverId: number, data: ChangePasswordModel): Observable<void> {
    return this.http.put<void>(environment.backendApi + `api/Driver/ChangePassword/${driverId}`, {
      password: data.password,
    });
  }

  changePin(driverId: number, pin: string): Observable<void> {
    return this.http.put<void>(environment.backendApi + `api/Driver/ChangePin/${driverId}`, {
      pin: pin,
    });
  }

  removePin(driverId: number): Observable<void> {
    return this.http.post<void>(environment.backendApi + `api/Driver/RemovePin/${driverId}`, null);
  }
}

